import { render, staticRenderFns } from "./ResumeLanding.vue?vue&type=template&id=d4c96d7e&"
import script from "./ResumeLanding.vue?vue&type=script&lang=js&"
export * from "./ResumeLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports